<template>
  <Navbar2 />
  <!-- Breadcrumb Area  -->
  <div class="breadcrumb-area services section-padding light-bg-1 pb-0">
    <div class="container">
      <div class="row">
        <div
          class="offset-xl-1 col-xl-10 offset-lg-1 col-lg-10 offset-md-1 col-md-10 col-12 text-center"
        >
          <div class="section-title">
            <p>Our Services</p>
            <h2>End-to-End Solutions for Your Tax & Accounting Needs</h2>
          </div>
        </div>
      </div>

      <div class="row mt-90">
        <div class="col-12">
          <div class="bread-bg">
            <img src="/assets/img/breadcrumb/service_banner.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>


  <ChooseUs />
  <Process />

  <ContactComponent />

  <Footer2 />
</template>

<script>
import Navbar2 from "@/components/Navbar2.vue";
import Footer2 from "@/components/Footer2.vue";
import ContactComponent from "@/components/ContactComponent.vue";
import Process from "@/components/Process.vue";
import Service2 from "@/components/service/Service2.vue";
import CTA2 from "@/components/cta/CTA2.vue";
import ChooseUs from "@/components/ChooseUs.vue";
export default {
  name: "Services",
  components: {
    Navbar2,
    Footer2,
    ContactComponent,
    Process,
    Service2,
    CTA2,
    ChooseUs,
  },

  mounted() {
    // Add structured data (JSON-LD) for SEO
    this.addStructuredData();
    // data-backround

    $("[data-background]").each(function () {
      $(this).css(
        "background-image",
        "url( " + $(this).attr("data-background") + "  )"
      );
    });

    //jQuery Animation
    new WOW().init();

    //Magnific Pop-up

    $(".video-play-btn").magnificPopup({
      type: "iframe",
    });
  },
  methods: {
    addStructuredData() {
      // Service schema
      const servicesData = {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "Tax and Accounting Services",
        "provider": {
          "@type": "Organization",
          "name": "Afino Tax Consultants",
          "url": "https://www.afinotax.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "W8 building, 5th floor, DAFZA",
            "addressLocality": "Dubai",
            "addressRegion": "Dubai",
            "addressCountry": "AE"
          },
          "telephone": "+971-54-566-8994",
          "email": "sales@afinotax.com"
        },
        "areaServed": {
          "@type": "Country",
          "name": "United Arab Emirates"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Tax and Accounting Services",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Corporate Tax Services"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "VAT Services"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Accounting & Bookkeeping"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Audit Support"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Business Setup & Consultancy"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Economic Substance Regulation (ESR)"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "AML & KYC Compliance"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Payroll & WPS Solutions"
              }
            }
          ]
        }
      };

      const script = document.createElement('script');
      script.id = 'structured-data-services';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(servicesData);
      document.head.appendChild(script);
    }
  },
  beforeUnmount() {
    const script = document.getElementById('structured-data-services');
    if (script) script.remove();
  },
};
</script>
